<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Product Infromation</div>
		</div>
		<div class="mt-2">
			<div class="d-flex flex-wrap">
				<v-col cols="12" class="px-0">
					<div class="d-flex justify-end">
						<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
						<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Search</div>
							</div>
						</v-btn>
					</div>
				</v-col>
			</div>
			<div class="d-flex flex-wrap mr-n3">
				<template v-if="loading">
					<v-col cols="6" sm="4" md="3" lg="3" xl="2" class="pl-0 pb-0 col-md-20" v-for="i in 5" :key="i + 'a'">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100 w-100 custom-skeleton">
							<v-skeleton-loader width="100%" height="150px" type="image" class="rounded-xl"></v-skeleton-loader>
							<v-skeleton-loader width="50%" type="text" class="mt-5"></v-skeleton-loader>
							<v-skeleton-loader width="100%" type="text" class="mt-2"></v-skeleton-loader>
							<v-skeleton-loader width="50%" type="text" class="mt-2"></v-skeleton-loader>
						</v-card>
					</v-col>
				</template>
				<template v-if="!loading">
					<template v-if="productList.length > 0">
						<v-col cols="6" sm="4" md="3" lg="3" xl="2" class="pl-0 pb-0 col-md-20" v-for="product in productList" :key="product.product_stock_id">
							<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100" >
								<div class="btn-detail">
									<v-btn depressed x-small fab class="primary" @click="showModalDetail(product.product_code)">
										<v-icon color="white">mdi-information-variant</v-icon>
									</v-btn>
								</div>
								<v-img eager contain height="150px" width="100%" class="rounded-xl" :src="product.product_image != '' ? product.product_image : require('/public/assets/image/user-pict.jpg')"></v-img>
								<div class="pt-3">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-size-11 product-name secondary--text" v-bind="attrs" v-on="on">{{ product.product_name }}</div>
										</template>
										<span>{{ product.product_name }}</span>
									</v-tooltip>
								</div>
								<div class="pt-1 pb-2 d-sm-flex">
									<div class="font-size-12 primary--text font-weight-bold">{{ product.product_price | toCurrencyFormat }}</div>
								</div>
								<div class="d-flex flex-wrap justify-space-between">
									<div class="font-size-10 cl-grey font-weight-500">{{ product.product_code }}</div>
								</div>
							</v-card>
						</v-col>
					</template>
					<v-col cols="12" sm="12" md="12" class="mt-3" v-if="productList.length == 0">
						<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
							<NoData></NoData>
							<div class="pt-3 text-center cl-secondary">No product list available.</div>
						</v-card>
					</v-col>
				</template>
			</div>
		</div>
		<ModalDetail ref="modalDetail"></ModalDetail>
		<ModalCari ref="modalCari" @action="cari"></ModalCari>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalDetail from './components/ModalDetail';
import ModalCari from './components/ModalCari';

export default {
	components: {
		ModalDetail,
		ModalCari
	},
	data() {
		return {
			loading: false,
			limit: 1000,
			page: 1
		}
	},
	computed: {
		...mapState('produk', ['productList', 'productDetail']),
	},
	methods: {
		...mapActions('produk', ['getProductList', 'getProductDetail']),

		getData() {
			this.loading = true
			this.getProductList({limit: 1000, page: 1}).then(() => {
				this.loading = false
			})
		},
		showModalDetail(code) {
			this.$refs.modalDetail.modalShow()
			this.getProductDetail({ code: code })
		},
		showSearch() {
			this.$refs.modalCari.modalShow()
		},
		reset() {
			this.params = []
			this.page = 1
			this.$refs.modalCari.reset()
      this.getData()
		},
		cari(data) {
      this.loading = true
			this.params = []
			this.page = 1

			if(data.code.value)
				this.params.push(data.code)
			if(data.name.value)
				this.params.push(data.name)
			this.getProductList(this.queryString({sort: 'product_id', dir: 'ASC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				this.$refs.modalCari.modalHide()
			})
      this.loading = false
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Product Information`)
		this.getData()
	},
};
</script>